import { FC } from 'react'
import { cn } from '@wellesley/ui'
import { Resend } from './Resend'
import { Inputs } from './Inputs'

export type PassCodeInputProps = {
  email?: string
  className?: string
  length?: number
  countdownTime?: number
  isError?: boolean
  errorMsg?: string
  onSubmit: (code: number) => void
  onResend?: () => void
  onChange?: (code: number) => void
  onFullFilled?: (isFullFilled: boolean) => void
}

export const PassCode: FC<PassCodeInputProps> = ({
  email,
  errorMsg,
  className,
  countdownTime = 30,
  isError,
  length = 6,
  onResend,
  onSubmit,
  onChange,
  onFullFilled,
}) => {
  return (
    <div className={cn('gap-s flex flex-col', className)}>
      {email && (
        <div className="mx-auto max-w-[450px] text-center text-base font-normal text-gray-900">
          <span className="align-middle">
            Enter the 6-digit code we&rsquo;ve sent to
          </span>
          <span className="pl-xxxs inline-block max-w-[450px] truncate align-middle">
            {email}
          </span>
        </div>
      )}
      <div className="relative">
        <Inputs
          isError={isError}
          length={length}
          onComplete={onSubmit}
          onChange={onChange}
          onFullFilled={onFullFilled}
        />
      </div>
      {isError && errorMsg && (
        <div className="text-center text-base font-normal text-red-500">
          {errorMsg}
        </div>
      )}
      {countdownTime && (
        <Resend countdownTime={countdownTime} onResend={onResend} />
      )}
    </div>
  )
}
